import React from 'react';

import { If } from 'utils';
import { UiKit } from 'components';
import { useSegment } from 'utils/hooks';
import { useExchangesConfig } from '../context';
import { ReactComponent as ExchangesPromoIcon } from 'assets/ss-icons/zero-state-icons/exchanges-promo.svg';

export default function Form() {
  const { track } = useSegment();
  const { data, errors, onChange, isProcessing } = useExchangesConfig();

  const handleExchangeToggle = value => {
    track('FTU Wizard Exchange Toggle Changed', {
      is_enabled: value
    });
    onChange({ isEnabled: value });
  };

  const handleDoLaterToggle = value => {
    track('FTU Wizard Exchange Do Later Toggled', {
      checked: value
    });
    onChange({ isAddedToDoLater: value });
  };

  return (
    <UiKit.Flex direction="column" gap="120">
      <UiKit.Radio.Group
        gap={12}
        name="exchange_allowed"
        value={data.isEnabled}
        onChange={handleExchangeToggle}
        disabled={isProcessing}
        error={errors.isEnabled}
      >
        <UiKit.Radio.Card value={true} label="Yes, I offer exchanges" />
        <UiKit.Radio.Card
          value={false}
          label="No, I don't want to offer exchanges"
        />
      </UiKit.Radio.Group>
      <If test={!data.isEnabled}>
        <UiKit.Card>
          <UiKit.Flex>
            <UiKit.Card.Body className="flex-fill">
              <UiKit.Flex
                direction="column"
                align="flex-start"
                justify="space-between"
                className="h-100"
              >
                <UiKit.Flex direction="column" gap={8}>
                  <UiKit.Text size="xl">
                    Turn Returns Into Opportunities with Exchanges
                  </UiKit.Text>
                  <UiKit.Text variant={700}>
                    <span>
                      Brands that offer seamless exchanges see up to 40% fewer
                      refund requests and retain up to 50% of revenue that would
                      otherwise be lost to returns.{' '}
                      {/* <a
                        href="https://www.shopify.com/retail/exchanges" // TODO: Update link
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Learn more
                      </a> */}
                    </span>
                  </UiKit.Text>
                </UiKit.Flex>
                <UiKit.Button
                  variant="primary"
                  onClick={() => handleExchangeToggle(true)}
                >
                  Start Offering Exchanges
                </UiKit.Button>
                <UiKit.Separator />
                <UiKit.Checkbox
                  label='Add to "Do Later"'
                  checked={data.isAddedToDoLater}
                  onChange={handleDoLaterToggle}
                />
              </UiKit.Flex>
            </UiKit.Card.Body>
            <ExchangesPromoIcon height="100%" className="flex-shrink-0" />
          </UiKit.Flex>
        </UiKit.Card>
      </If>
    </UiKit.Flex>
  );
}
